import React, { useState } from 'react';
import styled from 'styled-components';

import {
  Div, colors, weight, Figure,
} from 'globalStyle';
import { useFormProps, useInvestmentsUser } from 'hooks';
import { InputFormatNumber, ErrorText } from 'components/Form';
import { TextLight } from 'components/Texts';
import { Hollow } from 'components/Buttons';
import { userInvestmentService } from 'services';
import { getAmount } from 'util/getAmount';
import { Dialog, DialogContent } from '@material-ui/core';
import arrowLeft from 'assets/icons/arrowLeftHeader.svg';
import closeIcon from 'assets/icons/closeIcon.svg';
import { capitalizeFirstLetterString } from 'util/capitalizeFirstLetter';
import BalanceMobile from 'Layout/components/Menu/components/BalanceMobile';
import { formatNumber } from 'util/formatNumber';
import { SuccessfulInvestmentModal } from './SuccessfulInvestmentModal';

export const InvertModal = ({
  projectId,
  onSuccessfulInvert = () => {},
  isOpen,
  companyName,
  onClick,
  projectName,
  userData,
  minInvestmentAmount,
  currentAmount,
  currencyIso,
  project,
  handleGoRisk,
}) => {
  const {
    formProps,
    stateFormProps: {
      isLoading, setLoading, setError, errorMessage,
    },
  } = useFormProps({ errorToolTip: true, requiered: true });
  const { fetch } = useInvestmentsUser();
  const [successfulInvestment, setSuccessfulInvestment] = useState(false);
  const [amountInvested, setAmountInvested] = useState(0);

  const submitInvest = (form) => {
    setLoading(true);
    const amount = parseInt(form.amount.replaceAll('.', ''), 10);
    userInvestmentService({
      amount,
      idProject: projectId,
      isoName: userData?.wallet?.isoName || 'COP',
    })
      .then(() => {
        setLoading(false);
        fetch();
        setAmountInvested(amount);
        onSuccessfulInvert(currentAmount + amount);
        setSuccessfulInvestment(true);
      })
      .catch(({ message, messageFormat }) => {
        if (message === 'PROJECT_FAST_UPDATED') {
          submitInvest();
        }
        setLoading(false);
        setError(true, messageFormat);
      });
  };

  if (!userData) return null;
  if (successfulInvestment) {
    return (
      <SuccessfulInvestmentModal
        currentAmount={currentAmount + amountInvested}
        companyName={companyName}
        onClick={onClick}
        projectName={projectName}
        maxAmount={project?.maxAmount}
        amountInvested={amountInvested}
      />
    );
  }

  return (
    <Dialog
      open={isOpen}
      PaperProps={{
        style: { borderRadius: '20px' },
      }}
      maxWidth="md"
    >
      <Div isFlex justify="space-between" padding="20px 20px 0">
        <Figure
          style={{
            width: '22px',
            height: '25px',
            cursor: 'pointer',
          }}
          onClick={() => {
            onClick();
          }}
        >
          <img
            src={arrowLeft}
            alt="atrás"
            style={{
              width: '100%',
              height: '100%',
            }}
          />
        </Figure>
        <TextLight weight={weight.BOLD} mb={5} size={14} width="auto">
          Inversión
        </TextLight>
        <Figure
          style={{
            width: '15px',
            height: '18px',
            cursor: 'pointer',
          }}
          onClick={() => {
            onClick();
          }}
        >
          <img
            src={closeIcon}
            alt="cerrar"
            style={{
              width: '100%',
              height: '100%',
            }}
          />
        </Figure>
      </Div>
      <DialogContent
        style={{
          'max-width': '600px',
          padding: '0',
          width: '100%',
          overflowX: 'hidden',
        }}
        align="center"
      >
        <Div padding="20px 20px 0">
          <TextLight weight={weight.BOLD} mb={5} size={14} isUpper>
            {projectName}
          </TextLight>
          <TextLight size={12}>
            {`Por ${capitalizeFirstLetterString(companyName)}`}
          </TextLight>

          <Line margin="10px 0" />
          <Div width="100%" style={{ maxWidth: '300px' }}>
            <BalanceMobile />
          </Div>
          <TextLight
            color={colors.primary}
            weight={weight.BOLD}
            mb={5}
            width="auto"
            size={14}
          >
            Total recaudado
          </TextLight>
          <TextLight weight={weight.BOLD} width="auto" size={20}>
            {formatNumber(currentAmount, null, currencyIso)}
          </TextLight>
          <Line margin="20px 0" />
          <TextLight
            color={colors.primary}
            weight={weight.BOLD}
            mb={5}
            width="auto"
            size={14}
          >
            Meta del proyecto
          </TextLight>
          <TextLight weight={weight.BOLD} width="auto" size={20}>
            {formatNumber(project?.maxAmount, null, currencyIso)}
          </TextLight>

          <form>
            <InputFormatNumber
              title="¿Cuánto quieres invertir?"
              name="amount"
              placeholder={`Desde ${formatNumber(minInvestmentAmount, null, currencyIso)}`}
              validate={{
                max: (value) => getAmount(`${value}`) >= minInvestmentAmount
                  || `El monto ingresado debe ser mayor o igual a ${formatNumber(
                    minInvestmentAmount,
                  )}`,
                minValueMultiple: (value) => getAmount(`${value}`) % project?.minInvestmentAmount === 0
                  || `El monto ingresado debe ser múltiplo de ${formatNumber(
                    project?.minInvestmentAmount,
                  )}`,
              }}
              styles={{
                textAlign: 'start',
                width: '100%',
                margin: '30px 0 20px',
              }}
              {...formProps}
            />
            <ErrorText isCenter text={errorMessage} />

            <Div
              isFlex
              width="100%"
              justify="space-evenly"
              style={{ flexWrap: 'wrap', gap: '20px' }}
              margin="0 0 20px"
            >
              <Hollow
                isSubmit
                onColorType="primary"
                onClick={formProps.handleSubmit(submitInvest)}
                isLoading={isLoading}
                padding="12px 0"
                size="14px"
                style={{ borderRadius: '30px', width: '220px', height: '45px' }}
              >
                Invertir
              </Hollow>
              <Hollow
                isSubmit
                type="button"
                onColorType="white"
                color={colors.primary}
                onClick={handleGoRisk}
                padding="12px 0"
                size="14px"
                style={{ borderRadius: '30px', width: '220px', height: '45px' }}
              >
                Riesgos
              </Hollow>
            </Div>
          </form>
        </Div>
        <Div backgroundColor={colors.secondary} padding="15px 35px">
          <TextLight size={13} weight={weight.MEDIUM}>
            <span style={{ fontWeight: weight.BOLD, margin: '0 3px' }}>
              Recuerda:
            </span>
            El dinero de tu inversión estará congelado en tu cuenta y solo se
            utilizará para financiar este proyecto. Ten en cuenta que este
            proyecto tiene unos riesgos, consúltalos y cuando estes listo
            presiona invertir.
          </TextLight>
        </Div>
      </DialogContent>
    </Dialog>
  );
};

const Line = styled.div`
  width: 250px;
  margin: ${({ margin }) => margin && margin};
  height: 1px;
  border-bottom: 1px solid ${colors.GRAY_4};
`;
